// @flow
import Advertiser from 'common/modules/advertiser/domain/Advertiser';
import AdvertiserProfileAPI from '../services/AdvertiserProfileAPI';
import { getToken } from '../../authentication/selectors/sessionSelectors';
import type { GetState, Dispatch } from '../../../redux/types/redux';

export const UPDATE_ADVERTISER_NAME = 'advertiser/UPDATE_ADVERTISER_NAME';

export function updateAdvertiserName(advertiser: Advertiser) {
  return async (dispatch: Dispatch, getState: GetState) => {
    await AdvertiserProfileAPI.updateAdvertiser(getToken(getState()), advertiser);
    dispatch({ type: UPDATE_ADVERTISER_NAME, advertiser });
  };
}



// WEBPACK FOOTER //
// ./src/advertisers/modules/advertiser/actions/advertiserActions.js